import React, { useEffect, useRef, useState } from "react";
import $ from "jquery";
import { SET_GAME_BONUS_RESULT_POST } from "../../api/ApiConst";
import { callPostApi } from "../../api/ApiCaller";
import { getFormattedAmountWithDenomination } from "../../utils/TextUtils";

let interactionDisabled = false;

const Bonus09Bomb = ({ keyboardInput, gameSessionRecordId, onBonusRoundCompleted, walletBalance, denomination }) => {
    const [bonusWinnings, setBonusWinnings] = useState(0);
    const [premioValue, setPremioValue] = useState(0);
    const [selectedNo, setSelectedNo] = useState(0);
    const intervalRef = useRef(null);
    const premioRef = useRef(0);
    const refreshKey = useRef(Date.now());

    const defaultBombs = Array.from({ length: 5 }, () => ({
        disabled: false,
        revealed: false,
        exploded: false,
        bonusAmount: 0,
    }));
    const [bombs, setBombs] = useState(defaultBombs);

    const playSoundById = (id) => {
        const s = $("#" + id)[0];
        if (!s) return;
        s.currentTime = 0;
        const p = s.play();
        if (p !== undefined) p.catch(() => { });
    };
    const pauseSoundById = (id) => {
        const s = $("#" + id)[0];
        if (!s) return;
        if (!s.paused) {
            s.pause();
            s.currentTime = 0;
        }
    };


    useEffect(() => {
        if (!keyboardInput) return;
        const handleKey = (e) => {
            const key = e.key.toLowerCase();
            if (["t", "y", "j", "h", "m", "n", "v"].includes(key)) {
                setSelectedNo((prev) => (prev + 1) % 5);
            } else if (key === "b") {
                setBombs((current) => {
                    if (!current[selectedNo]?.disabled) {
                        handleBombClick(current[selectedNo], selectedNo, current);
                    }
                    return current;
                });
            }
        };
        window.addEventListener("keydown", handleKey);
        return () => window.removeEventListener("keydown", handleKey);
    }, [keyboardInput, selectedNo]);


    useEffect(() => {
        return () => { if (intervalRef.current) clearInterval(intervalRef.current); };
    }, []);

    const handleBombClick = (bomb, index, currentBombs) => {
        if (interactionDisabled || bomb?.disabled) return;
        interactionDisabled = true;

        const payload = {
            bonusType: "Bonus09Bomb",
            recordId: gameSessionRecordId,
            tileNumber: index,
        };

        callPostApi(SET_GAME_BONUS_RESULT_POST, payload, {}, (response) => {
            if (response?.errorCode === 0) {
                const res = response.responsePacket;
                const bonusNumber = res?.bonusDetails?.bonus || 0;
                const totalWinnings = res?.totalWinnings || 0;

                if (bonusNumber > 0) {
                    playSoundById("bomb09Select");
                    setBonusWinnings((prev) => prev + bonusNumber);

                    setBombs((prev) => {
                        const updated = [...prev];
                        updated[index] = { ...updated[index], disabled: true, revealed: true, bonusAmount: bonusNumber };
                        return updated;
                    });

                    setTimeout(() => {
                        const targetValue = premioRef.current + bonusNumber;
                        premioRef.current = targetValue;
                        setPremioValue(targetValue);
                    }, 500);

                    const allUsed = currentBombs.filter(b => b.disabled).length + 1 === 5;
                    if (allUsed) {
                        pauseSoundById("bomb09Bg");
                        setTimeout(() => {
                            onBonusRoundCompleted(totalWinnings);
                        }, 2500);
                    }
                } else {
                    playSoundById("bomb09Explode");
                    pauseSoundById("bomb09Bg");

                    setBombs((prev) =>
                        prev.map((b, i) =>
                            i === index
                                ? { ...b, disabled: true, exploded: true }
                                : { ...b, disabled: true }
                        )
                    );

                    setTimeout(() => {
                        onBonusRoundCompleted(totalWinnings);
                    }, 3000);
                }
            }
            setTimeout(() => { interactionDisabled = false; }, 800);
        });
    };

    const drawHeader = () => (
        <div className="header">
            <div className="row align-content-center">
                <div className="col-4">
                    <div className="d-flex align-content-center gap-2">
                        <div className="btn-heading">Creditos</div>
                        <div className="header-custom-btn">{getFormattedAmountWithDenomination(walletBalance, denomination)}</div>
                    </div>
                </div>
                <div className="col-4">
                    <div className="d-flex align-content-center gap-2 justify-content-center">
                        <div className="btn-heading">Bonus</div>
                        <div className="header-custom-btn">{bonusWinnings}</div>
                    </div>
                </div>
                <div className="col-4">
                    <div className="d-flex align-content-center gap-2 justify-content-end">
                        <div className="btn-heading">Premio</div>
                        <div className="header-custom-btn">{premioValue}</div>
                    </div>
                </div>
            </div>
        </div>
    );

    return (
        <>
            <div className='bomba-bonus d-flex justify-content-center align-items-center h-100 w-100'>
                <div className='position-relative d-flex align-items-center justify-content-center w-100 h-100'>
                    <img className='img-fluid h-100' style={{ width: "95%" }} src="assets/img/bomba/bomba-bonus/tela.png" alt="" />
                    <div className='img-animation-content'>
                        {/* {drawHeader()} */}
                        <div className="img-item-box w-100 d-flex align-items-center justify-content-center">
                            {[0, 1, 2, 3, 4].map((index) => (
                                <span
                                    key={index}
                                    className={selectedNo === index ? "bomb-selected bomba-images" : "bomba-images"}
                                    style={{ cursor: bombs[index].disabled ? "not-allowed" : "pointer", opacity: bombs[index].disabled && !bombs[index].revealed && !bombs[index].exploded ? 0.5 : 1 }}
                                    onClick={() => { if (!interactionDisabled) handleBombClick(bombs[index], index, bombs); }}
                                >
                                    {!bombs[index].revealed && !bombs[index].exploded && (
                                        <img className='img-fluid' src="assets/img/bomba/bomba-bonus/bomba.gif" alt="" />
                                    )}
                                    {(bombs[index].revealed || bombs[index].exploded) && (
                                        <img className='img-fluid' src={`assets/img/bomba/bomba-bonus/bomba-animated.gif?v=${refreshKey.current}-${index}`} alt="" />
                                    )}
                                </span>
                            ))}
                        </div>
                        <span className='bonus-text-content'>{premioValue}</span>
                    </div>
                </div>
            </div>

            <div style={{ display: "none" }}>
                <audio id="bomb09Select"><source src="assets/bomb09Select.ogg" type="audio/mpeg" /></audio>
                <audio id="bomb09Explode"><source src="assets/bomb09Explode.mp3" type="audio/mpeg" /></audio>
            </div>
        </>
    );
};

export default Bonus09Bomb;
